import { getGlobalConfig } from '../global/ConfigProvider';

export function useCsrfToken() {
  const { getCsrfToken } = getGlobalConfig();
  return getCsrfToken();
}
